export * from './lib/shared-role-group-picker.module';
export * from './lib/role-group-picker.component';
